module.exports = __webpack_public_path__ + "img/yw_xjyd.3419fe77.svg";